import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@wds/box';
import { Grid } from '@wds/grid';

import AppCard from '../AppCard';

const AppsGrid = ({ apps = [] }) => (
  <Box mt={3}>
    <Grid noBleeds data-testid="AppsGrid__Grid">
      {apps.map(app => (
        <Grid.Item lg={4} md={6} sm={12} xs={12}>
          <AppCard key={app.id} app={app} />
        </Grid.Item>
      ))}
    </Grid>
  </Box>
);

AppsGrid.propTypes = {
  apps: PropTypes.arrayOf(
    PropTypes.shape({
      encryptedAppId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      tagline: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      categories: PropTypes.arrayOf(PropTypes.number),
    })
  ).isRequired,
};

export default AppsGrid;
